/**
 * useSearchCatalogStats — what the search covers, for the loader's stats row:
 * games cached, markets, lines, ≈prices, sportsbooks. Written by
 * scripts/buildSearchCatalogStats.js to site_config/search_catalog_stats
 * (public read). Read once per session; null until loaded or when absent,
 * and the loader then hides the row rather than showing made-up numbers.
 */
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

let _cached = undefined;   // undefined = not fetched, null = absent/failed
let _pending = null;

function load() {
    if (_cached !== undefined) return Promise.resolve(_cached);
    if (!_pending) {
        _pending = getDoc(doc(db, 'site_config', 'search_catalog_stats'))
            .then((snap) => {
                const d = snap.exists() ? snap.data() : null;
                _cached = d && Number.isFinite(d.lines) ? {
                    games: d.games, markets: d.markets, lines: d.lines,
                    prices: d.prices_estimate, sportsbooks: d.sportsbooks_seen,
                } : null;
                return _cached;
            })
            .catch(() => { _cached = null; return null; });
    }
    return _pending;
}

export function useSearchCatalogStats() {
    const [stats, setStats] = useState(_cached || null);
    useEffect(() => {
        let alive = true;
        load().then((s) => { if (alive) setStats(s); });
        return () => { alive = false; };
    }, []);
    return stats;
}

/** 898 → "898", 6697 → "6,697", 166317 → "166K", 1025818 → "1.03M". */
export function formatStat(n) {
    if (!Number.isFinite(n)) return '—';
    if (n >= 1e6) return `${(n / 1e6).toFixed(n >= 1e7 ? 1 : 2)}M`;
    if (n >= 1e5) return `${Math.round(n / 1e3)}K`;
    return Math.round(n).toLocaleString('en-US');
}
